import { Component, OnDestroy, OnInit } from '@angular/core';
import { PaymentPlanService } from '../../../services/payment-plan/payment-plan.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, switchMap, take, takeUntil } from 'rxjs/operators';
import { defer, Subject } from 'rxjs';
import { StripeApiService } from '@aiwyn/api';
import { ConfigService, GetBusinessEntities } from '@aiwyn/config';
import { Store } from '@ngxs/store';
import { GetPaymentPlans } from './state';
import { AuthAdaptorService } from '@aiwyn/auth';
import { Router } from '@angular/router';
import { GetAutoPayClients, GetClientCurrencies } from '@aiwyn/common/settings';
import { ROUTE_TOKEN_LOGIN } from '../../../routing-constants';
import { ignoreFalsy } from '@aiwyn/shared';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  standalone: false,
})
export class SettingsComponent implements OnInit, OnDestroy {

  private _unsubscribe$ = new Subject<void>();

  constructor(
    public paymentPlanService: PaymentPlanService,
    private stripeApiService: StripeApiService,
    private authAdaptor: AuthAdaptorService,
    private router: Router,
    public configService: ConfigService,
    private spinner: NgxSpinnerService,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    this.spinner.show();

    if (this.authAdaptor.user.isAnonymous() && !this.authAdaptor.isAdmin) {
      this.router.navigateByUrl(ROUTE_TOKEN_LOGIN);
    }

    this.store.dispatch(new GetBusinessEntities(defer(() => this.stripeApiService.getBusinessEntities()))).pipe(
      takeUntil(this._unsubscribe$),
      finalize(() => this.spinner.hide()),
    ).subscribe();

    this.configService.configValuesLoaded$.pipe(
      ignoreFalsy(),
      switchMap(_ => this.store.dispatch([
        new GetPaymentPlans(),
        new GetAutoPayClients(),
        new GetClientCurrencies(this.authAdaptor.user.getClientIdList()),
      ])),
      take(1),
      takeUntil(this._unsubscribe$)
    ).subscribe();
  }

  /**
   * Destroy subscriptions.
   */
  ngOnDestroy() {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

}
